/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Link} from 'react-router-dom'
import {CustomOptOutData} from '../../../../_metronic/helpers'
import WSButton from '../../../../_metronic/helpers/components/WSButton/WSButton'
//components

//scss
import './CustomOptOut.scss'
import NodataYet from '../../../Components/NodataYet'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

type Props = {
  className?: string
}

const CustomOptOutPageTable: React.FC<Props> = ({className}) => {
  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5 ms-3'>
        <h3 className='card-title align-items-start flex-column'>
          <div>
            <span className='fw-bolder fs-2 mb-1'>Custom Opt Out</span>
            <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id="tooltip-bottom">
                  <div>
                    <span>Create a custom opt-out form to understand why customers unsubscribe. Gain valuable insights to improve your messaging, offers, and overall customer experience.</span>
                  </div>
                </Tooltip>}
              >
                <i
                  className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                />
            </OverlayTrigger>
          </div>
          <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
        </h3>
        <div className='card-toolbar d-flex'>
          <Link to='create'>
            <a className='btn btn-sm btn-primary'>Create Opt-out</a>
          </Link>
        </div>
      </div>

      {CustomOptOutData?.length > 0 ? (
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-100 align-middle gs-2 gy-4'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th className='ps-4 min-w-125px'>NAME</th>
                  <th className='min-w-125px'>CREATED</th>
                  <th className='min-w-200px'>OPTION 1</th>
                  <th className='min-w-200px'>OPTION 2</th>
                  <th className='min-w-200px'>OPTION 3</th>
                  <th className='min-w-200px'>OPTION 4</th>
                  <th className='min-w-120px text-end'>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {CustomOptOutData?.map((data: any, idx: number) => (
                  <tr key={idx}>
                    <td className='ps-3'>
                      <a className='text-dark fw-400 d-block mb-1 fs-6'>{data?.name}</a>
                    </td>
                    <td>
                      <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.createdAt}</span>
                      <span className='text-gray-600'>{data?.nameSub}</span>
                    </td>
                    <td>
                      <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.option1}</span>
                    </td>
                    <td>
                      <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.option2}</span>
                    </td>
                    <td>
                      <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.option3}</span>
                    </td>
                    <td>
                      <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.option4}</span>
                    </td>
                    <td className='ms-2'>
                      <WSButton
                        className={'btn btn-sm btn-icon btn-light btn-active-light-primary me-2'}
                        iconClass='svg-icon-2'
                        iconPath={'/media/icons/duotune/art/art005.svg'}
                      />
                      <WSButton
                        className={'btn btn-sm btn-icon btn-light btn-active-light-primary'}
                        iconClass='svg-icon-2'
                        iconPath={'/media/icons/duotune/general/gen027.svg'}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <NodataYet />
      )}
    </div>
  )
}

export default CustomOptOutPageTable
